<section class="qr-wrapper">
  <h5 class="heading__5 text-gray">
    Please scan the QR Code below to make Payment
  </h5>
  <div class="icon-wrapper">
    <img src="../../../assets/rexpay/QR_icon.png" alt="" />
  </div>
</section>
